import { HIDE_SIDEBAR, SHOW_SIDEBAR, TOOGLE_SIDEBAR, SET_HEADER_TITLE, HOME_CLICK, SET_ACTIVE_SIDEBAR_ITEM } from "../constants";

const initialState = {
  isSideBar: false,
  headerTitle: '',
  homeClick: false,
  activeSidebarItem: "App Marketplace",
};

const layoutReducer = (state = initialState, action = null) => {
  switch (action.type) {

    case SHOW_SIDEBAR:
      return {
        ...state,
        isSideBar: true,
      };
    case HIDE_SIDEBAR:
      return {
        ...state,
        isSideBar: false,
      };
    case HOME_CLICK:
      return {
        ...state,
        homeClick:action.payload
      }
    case SET_HEADER_TITLE:
      return {
        ...state,
        headerTitle: action.payload,
      };
    case TOOGLE_SIDEBAR:
      return {
        ...state,
        isSideBar: !state.isSideBar,
      };
    case SET_ACTIVE_SIDEBAR_ITEM:
      return {
        ...state,
        activeSidebarItem: action.payload,
      };
    default:
      return state;
  }
};

export default layoutReducer;
